// Element for creating and editing webhook templates and displaying tokens

export class WebhookTemplate extends HTMLElement {
  constructor(name, type, template, id) {
    super();
    this.name = name;
    this.type = type;
    this.template = template;
    this.temp_id = id;
  }
  async connectedCallback() {
    let tokens = await fetch(`/admin/domains/action_templates/all_tokens.json`)
    let data = await tokens.json()
    let tokenList = data.map(token => `<tr><td>${token.description}</td><td>%${token.token_name}%</td></tr>`).join("")
    console.log(data)
    this.innerHTML = `<div class="row">
                        <div class="col-sm-12">
                          <label>Template Name</label>
                          <input id="template-name" class="form-control" type="text" placeholder="Template Name">
                        </div>
                        <div class="col-sm-12">
                          <label>Template Type</label>
                          <select id="template-type" class="form-control">
                            <option value="">Select</option>
                            <option value="JSON">JSON</option>
                            <option value="XML">XML</option>
                          </select>
                        </div>
                        <div id="template-div" class="col-sm-12">
                        <label>Copy and Paste your Template</label>
                        <label id="token-show"><a>View Tokens</a></label>
                        <label id="token-hide" style="display:none;"><a>Hide Tokens</a></label>
                        <textarea id="template-content"></textarea>
                        </div>
                        <div id="token-div" class="col-sm-6" style="display:none;">
                          <label>Tokens</label>
                          <div id="token-list">
                            <table id="token-table" class="table" style="width:100%; display:table;">
                              <thead>
                                <tr>
                                  <th>Description</th>
                                  <th>Token</th>
                                </tr>
                                ${tokenList}
                              </thead>
                            </table>
                          </div>
                        </div>
                        <div class="col-sm-12">
                          <button id="save-template" class="btn btn-primary pull-right">Save</button>
                          <button id="cancel-template" class="btn btn-outline-secondary pull-right">Cancel</button>
                        </div>
                      </div>`;
    // this.init();
    this.name && this.type && this.template && this.temp_id ? this.setForm() : null;
    // Save
    this.querySelector("#save-template").addEventListener("click", async function(e) {
      e.preventDefault();
      let template_data = {
        template: {
          name: this.querySelector('#template-name').value,
          template_type: this.querySelector('#template-type').value,
          template: this.querySelector('#template-content').value,
          action_template_id: this.temp_id ? this.temp_id : null
        }
      };

      if(this.validate(template_data)) {
        let res = await fetch('/admin/action_templates', {
          headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                    'Content-type': 'application/json'},
          method: 'POST',
          body: JSON.stringify(template_data)
        });
        let data = await res.json();
        Common.notify('Successfully saved Webhook', 'success');
        this.closest("all-webhooks").reloadData();
        this.remove();
        document.querySelector("all-webhooks").showSelf();
      }
    }.bind(this));

    //Show token element
    this.querySelector("#token-show").addEventListener("click", function() {
      this.querySelector("#token-div").style.display = "initial";
      this.querySelector("#template-div").classList = "col-sm-6";
      this.querySelector("#token-show").style.display = "none";
      this.querySelector("#token-hide").style.display = "initial";
    }.bind(this));
    // Hide token element
    this.querySelector("#token-hide").addEventListener("click", function() {
      this.querySelector("#token-div").style.display = "none";
      this.querySelector("#template-div").classList = "col-sm-12";
      this.querySelector("#token-show").style.display = "initial";
      this.querySelector("#token-hide").style.display = "none";
    }.bind(this));

    this.querySelector("#cancel-template").addEventListener("click", function() {
      this.remove();
      document.querySelector("all-webhooks").showSelf();
    }.bind(this));
  }

  // init() {
  //   this.table = $('#token-table').DataTable({
  //     paging: false,
  //     "ajax": "/admin/domains/action_templates/all_tokens",
  //     "columns": [
  //       { 
  //         "data": "description"
  //       },
  //       {
  //         data: "token_name",
  //         "render": function(data, type, row) {
  //           return `%${data}%`;
  //         },
  //         "class": "text-center"

  //       }
  //     ],
  //     "order": [[0, 'asc']]
  //   });
  // }

  setForm() {
    this.querySelector("#template-name").value = this.name;
    this.querySelector("#template-type").value = this.type;
    this.querySelector("#template-content").value = this.template;
  }

  validate(template_data) {
    this.querySelector('#template-name').classList.remove("error");
    this.querySelector('#template-content').classList.remove("error");
    let required_field_missing = false;
    if(template_data.template.name.trim().length == 0) {
      required_field_missing = true;
      this.querySelector('#template-name').classList.add("error");
    }

    if(template_data.template.template.trim().length == 0) {
      required_field_missing = true;
      this.querySelector('#template-content').classList.add("error");
    }

    if(required_field_missing) {
      Common.notify('Required Webhook fields missing.', 'error');
    }
    return !required_field_missing;
  }
}

customElements.define("webhook-template", WebhookTemplate);